<template>
  <div class="home">
    <loading
      :active.sync="loader.isLoading"
      :can-cancel="loader.canCancel"
      :is-full-page="loader.fullPage"
      :color="loader.color"
      :height="loader.height"
      :width="loader.width"
      :background-color="loader.backgroundColor"
      :loader="loader.loader">
      </loading>
    <VendorList v-show="listView" @newVendor="onClickNewFromList" @editVendor="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <VendorForm v-show="formView" :vendor="vendor" @backClicked="onBackChild"/>
  </div>
</template>

<script>
// @ is an alias to /src
import VendorList from '@/components/vendor/VendorList.vue'
import VendorForm from '@/components/vendor/VendorForm.vue'
import Axios from 'axios'
import Loading from 'vue-loading-overlay'
import { vendorUrl, getHeader } from '../config'

export default {
  name: 'Vendor',
  components: {
    VendorList,
    VendorForm,
    Loading
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      vendor: {
        id: null,
        vendor_no: null,
        type_id: null,
        name: null,
        email: null,
        phone: null,
        mobile: null,
        vat: null,
        address: null,
        city_id: null,
        state_id: null,
        postalcode: null,
        type: null,
        alias: null,
        contact: [{
          id: null,
          vendor_no: null,
          name: null,
          email: null,
          phone: null,
          mobile: null,
          vat: null,
          address: null,
          city_id: null,
          state_id: null,
          postalcode: null,
          notes: null
        }],
        purchasing: [{
          id: null,
          idPurchasing: null,
          purchasing_no: null,
          purchasing_date: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          status: null,
          product_no: null,
          description: null,
          qty: '0',
          uom_id: null,
          price: '0',
          qty_done: null,
          product: null
        }],
        payments: [{
          id: null,
          sale_no: null,
          payment_no: null,
          payment_date: null,
          price: null,
          method_id: null,
          type_id: null,
          bank_id: null,
          notes: null,
          lock: false,
          journal_code: null,
          status: null,
          prepayment_date: null,
          qroup_no: null,
          account_code: null,
          report_no: null
        }]
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.vendor = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.vendor = {
        id: null,
        vendor_no: null,
        type_id: null,
        name: null,
        email: null,
        phone: null,
        mobile: null,
        vat: null,
        address: null,
        city_id: null,
        state_id: null,
        postalcode: null,
        type: null,
        alias: null,
        contact: [{
          id: null,
          vendor_no: null,
          name: null,
          email: null,
          phone: null,
          mobile: null,
          vat: null,
          address: null,
          city_id: null,
          state_id: null,
          postalcode: null,
          notes: null
        }],
        purchasing: [{
          id: null,
          idPurchasing: null,
          purchasing_no: null,
          purchasing_date: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          status: null,
          product_no: null,
          description: null,
          qty: '0',
          uom_id: null,
          price: '0',
          qty_done: null,
          product: null
        }],
        payments: [{
          id: null,
          sale_no: null,
          payment_no: null,
          payment_date: null,
          price: null,
          method_id: null,
          type_id: null,
          bank_id: null,
          notes: null,
          lock: false,
          journal_code: null,
          status: null,
          prepayment_date: null,
          qroup_no: null,
          account_code: null,
          report_no: null
        }]
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.vendor = {
        id: null,
        vendor_no: null,
        type_id: null,
        name: null,
        email: null,
        phone: null,
        mobile: null,
        vat: null,
        address: null,
        city_id: null,
        state_id: null,
        postalcode: null,
        type: null,
        alias: null,
        contact: [{
          id: null,
          vendor_no: null,
          name: null,
          email: null,
          phone: null,
          mobile: null,
          vat: null,
          address: null,
          city_id: null,
          state_id: null,
          postalcode: null,
          notes: null
        }],
        purchasing: [{
          id: null,
          idPurchasing: null,
          purchasing_no: null,
          purchasing_date: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          status: null,
          product_no: null,
          description: null,
          qty: '0',
          uom_id: null,
          price: '0',
          qty_done: null,
          product: null
        }],
        payments: [{
          id: null,
          sale_no: null,
          payment_no: null,
          payment_date: null,
          price: null,
          method_id: null,
          type_id: null,
          bank_id: null,
          notes: null,
          lock: false,
          journal_code: null,
          status: null,
          prepayment_date: null,
          qroup_no: null,
          account_code: null,
          report_no: null
        }]
      }
      const query = Object.assign({}, this.$route.query)
      delete query.vendor
      delete query.form
      // this.$router.replace({ query })
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    },
    getEditVendor: function (id) {
      this.$Progress.start()
      this.loader.isLoading = true
      Axios.get(vendorUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.listView = false
          this.formView = true
          this.vendor = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error.response)
        })
    }
  },
  mounted () {
    this.$store.dispatch('getStateList')
    this.$store.dispatch('getCityList')
    this.$store.dispatch('getvendorTypeList')
    this.$store.dispatch('getRowTable')
    var form = this.$route.query.form
    var vendor = this.$route.query.vendor
    if (form === 'true') {
      if (vendor !== null) {
        this.getEditVendor(vendor)
      }
    }
  }
}
</script>
